import { render, staticRenderFns } from "./deleteOwnerCar.vue?vue&type=template&id=47bbba5f"
import script from "./deleteOwnerCar.vue?vue&type=script&lang=js"
export * from "./deleteOwnerCar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports